import { Field } from 'components/Wizards/Field/Field'
import { Select } from 'components/Select/Select'
import { Item } from '@react-stately/collections'

type Props = {
  gender?: string
  onUpdate: (gender: string) => void
  labelColor?: string
}

const RepresentationGender = ({ gender, onUpdate, labelColor }: Props) => {
  return (
    <Field label="Gender" labelType="label" data-testid="representation-gender" labelColor={labelColor}>
      <Select
        aria-label="Representation gender"
        variant="secondary"
        selectedKey={gender || 'all'}
        onSelectionChange={(key) => onUpdate(key as string)}
        placeholder="Select gender"
        size="lg"
        useFullWidth
      >
        <Item key="all">All Genders</Item>
        <Item key="women">Women</Item>
        <Item key="men">Men</Item>
      </Select>
    </Field>
  )
}

export { RepresentationGender }
